import { slice } from '../data/slice.js';
import { hashFunction } from './hashFunction.js';
export const getFunctionSelector = (fn) => slice(hashFunction(fn), 0, 4);
//# sourceMappingURL=getFunctionSelector.js.map